var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3969 10.2937V11.6813L26.7594 7.8375C24.2469 6.39375 20.7406 6.39375 18.2469 7.8375L11.6094 11.7V10.2937C11.6094 6.075 13.9156 3.75 18.1344 3.75H26.8719C31.0906 3.75 33.3969 6.075 33.3969 10.2937Z",
    fill: "url(#paint0_linear_955_5861)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.45 14.9469L33.1875 14.8156L30.6375 13.3531L25.35 10.2969C23.7375 9.35938 21.2625 9.35938 19.65 10.2969L14.3625 13.3344L11.8125 14.8344L11.475 15.0031C8.19375 17.2156 7.96875 17.6281 7.96875 21.1719V29.6469C7.96875 33.1906 8.19375 33.6031 11.55 35.8719L19.65 40.5406C20.4562 41.0281 21.4688 41.2344 22.5 41.2344C23.5125 41.2344 24.5438 41.0094 25.35 40.5406L33.525 35.8156C36.825 33.6031 37.0312 33.2094 37.0312 29.6469V21.1719C37.0312 17.6281 36.8062 17.2156 33.45 14.9469ZM27.7313 25.3156L26.5875 26.7219C26.4 26.9281 26.2688 27.3219 26.2875 27.6031L26.4 29.4031C26.475 30.5094 25.6875 31.0719 24.6562 30.6781L22.9875 30.0031C22.725 29.9094 22.2937 29.9094 22.0312 30.0031L20.3625 30.6594C19.3312 31.0719 18.5438 30.4906 18.6188 29.3844L18.7312 27.5844C18.75 27.3031 18.6187 26.9094 18.4312 26.7031L17.2688 25.3156C16.5562 24.4719 16.875 23.5344 17.9437 23.2531L19.6875 22.8031C19.9688 22.7281 20.2875 22.4656 20.4375 22.2406L21.4125 20.7406C22.0125 19.8031 22.9688 19.8031 23.5875 20.7406L24.5625 22.2406C24.7125 22.4844 25.05 22.7281 25.3125 22.8031L27.0563 23.2531C28.125 23.5344 28.4438 24.4719 27.7313 25.3156Z",
    fill: "url(#paint1_linear_955_5861)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_955_5861",
    x1: 22.5031,
    y1: 3.75,
    x2: 22.5031,
    y2: 11.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B484F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6949FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_955_5861",
    x1: 22.5,
    y1: 9.59375,
    x2: 22.5,
    y2: 41.2344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B484F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6949FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/award.e7def766aa6caf23ab37a0aad1f02594.svg";
export { ForwardRef as ReactComponent };